import React from 'react'
import { useWordPressPage } from '../uses/useWordPressPage'
import FullPageLayout from '../components/FullPageLayout'
import AccordionPage from '../components/AccordionPage'

const path = require('path')
const SLUG = path.basename(__filename).split('.')[0]

export default () => {
  const page = useWordPressPage(SLUG)
  return (
    <FullPageLayout>
      <div id="page-content" />
      <div className="page-content text-content">
        <h1>{page.title}</h1>
        <div
          className="headlines"
          dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
        />
        <div
          className="event-media media-text"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </div>
      <AccordionPage page={page} />
    </FullPageLayout>
  )
}
